import Vue from 'vue'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import Mint from 'mint-ui'
import config from './config'
import init from '@ivy/fts'
import store from './store/store'
import { closeAll } from '@ivy/fts/showDiv'
import gallery from 'img-vuer'
import Vconsole from 'vconsole'

import 'swiper/dist/css/swiper.min.css' // TODO css优化
Vue.component('swiper', async () => {
  const { swiper } = await import('vue-awesome-swiper')
  return swiper
})
Vue.component('swiper-slide', async () => {
  const { swiperSlide } = await import('vue-awesome-swiper')
  return swiperSlide
})
Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: true, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true, // preload images in the same group, default true
  sliderBackgroundColor: 'rgba(0,0,0,0.6)',
  sliderZIndex: 1001,
})
init({ Vue, router, axios, config, Mint, openSentry: true })
Vue.prototype.$store = store
Vue.config.productionTip = false
router.afterEach((to, from) => {
  console.log('to2', to)
  window.scrollTo(0, 0)
  closeAll()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

if (config.env != 'production') {
  new Vconsole()
}
